import type { EvalFinding } from '@queries/evalRuns';

/**
 * Findings the AI resolution check will assess: still canonical and not
 * ruled invalid by an SME. Closed (resolved / dismissed) findings are
 * included — the check re-judges them too and the card shows that verdict
 * as a second opinion, without reopening anything.
 *
 * Mirrors `backend/domain/evals/resolution/openFindings.ts` — the two must
 * agree, or the drawer offers a check the trigger guard then refuses with
 * "nothing to assess". Deliberately NOT the same set as the drawer's visible
 * list, which keeps false positives (they are still findings a reviewer may
 * want to read) and follows the duplicates toggle.
 */
export const isAssessableFinding = (finding: EvalFinding): boolean =>
  !finding.superseded_by && finding.grade !== 'FALSE_POSITIVE';
